import axios from 'axios';
import { API_URL, HELPAPIHOME } from './config';

const newfileheaders = {
    timeout: 15 * 60 * 1000,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
};

class HelpAndCommunicationService {

    constructor() {

        this.GetHelpCategories = () => (axios.post(`${HELPAPIHOME}gethelpcategories`, null));
        this.GetHelpMenus = (payload) => (axios.post(`${HELPAPIHOME}gethelpmenus`, payload));
        this.GetHelpTopicsByCriteria = (payload) => (axios.post(`${HELPAPIHOME}gethelptopicsbycriteria`, payload));
        this.GetHelpTopicByMenuName = (payload) => (axios.post(`${HELPAPIHOME}gethelptopicbymenuname`, payload));
        this.GetHelpTopics = (payload) => (axios.post(`${HELPAPIHOME}gethelptopics`, payload));
        this.GetHelpTopic = (payload) => (axios.post(`${HELPAPIHOME}gethelptopic`, payload));
        this.GetHelpTags = () => (axios.post(`${HELPAPIHOME}gethelptags`, null));
        this.GetHelpFranchise = () => (axios.post(`${HELPAPIHOME}gethelpfranchise`, null));
        this.CreateHelpTopics = (payload) => (axios.post(`${HELPAPIHOME}createhelptopic`, payload, newfileheaders));
        this.UpdateHelpTopic = (payload) => (axios.post(`${HELPAPIHOME}updatehelptopic`, payload, newfileheaders));
        this.CreateSubCategory = (payload) => (axios.post(`${HELPAPIHOME}createhelpsubcategory`, payload, newfileheaders));
        this.UpdateSubCategory = (payload) => (axios.post(`${HELPAPIHOME}updatehelpsubcategory`, payload, newfileheaders));
        this.DeleteIds = (payload) => (axios.post(`${HELPAPIHOME}deletehelptopics`, payload));
        this.DeleteSubCategories = (payload) => (axios.post(`${HELPAPIHOME}deletehelpsubcategories`, payload));
        this.GetCategories = (payload) => (axios.post(`${HELPAPIHOME}getcategories`, payload));
        this.GetSubCategory = (payload) => (axios.post(`${HELPAPIHOME}getsubcategories`, payload));
        this.GetSubCategoriesbyCategoryId = (payload) => (axios.post(`${HELPAPIHOME}getsubcategories`, payload));
        this.GetHelpTopicAttributeName = () => (axios.post(`${HELPAPIHOME}gethelptopicattributename`));
        this.GetHelpTopicAttributeValues = (payload) => (axios.post(`${HELPAPIHOME}gethelptopicattributevalues`, payload));
        this.DeleteHelpCategories = (payload) => (axios.post(`${HELPAPIHOME}deletehelpcategories`, payload));
        this.DeleteHelpTags = (payload) => (axios.post(`${HELPAPIHOME}deletehelptags`, payload));
    }
}
export default new HelpAndCommunicationService();